import { AlertMessage } from '../models';

export interface ApiModel {
    api: (...args: string[]) => string;
    successMessage?: AlertMessage;
    errorMessageHandler?: (error?: any) => AlertMessage;
}

// TODO: make unique errors messages for every request
const defaultDescription = (error: any) => `Server returned ${error.status} for this request`;

export type CommonApi = {
    getMyUser?: ApiModel;
    getMyProducts?: ApiModel;
};

export const UsersApi: CommonApi = {
    getMyUser: { api: () => 'users/me' },
    getMyProducts: {
        api: () => 'users/me/products',
        errorMessageHandler: (error) => ({
            message: 'Failed to load products',
            description: defaultDescription(error)
        })
    }
};
